// Main Theme Configuration for Fronic Media Admin
// Combines palette, typography, and component overrides

import { createTheme } from '@mui/material/styles';
import palette from './palette';
import typography from './typography';
import components from './components';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: palette.primary.main,
      light: palette.primary.light,
      dark: palette.primary.dark,
      contrastText: palette.primary.contrastText,
      gradient: palette.primary.gradient,
      gradientHover: palette.primary.gradientHover,
    },
    secondary: {
      main: palette.secondary.main,
      light: palette.secondary.light,
      dark: palette.secondary.dark,
      contrastText: palette.secondary.contrastText,
    },
    success: {
      main: palette.success.main,
      light: palette.success.light,
      dark: palette.success.dark,
      contrastText: palette.success.contrastText,
    },
    error: {
      main: palette.error.main,
      light: palette.error.light,
      dark: palette.error.dark,
      contrastText: palette.error.contrastText,
    },
    warning: {
      main: palette.warning.main,
      light: palette.warning.light,
      dark: palette.warning.dark,
      contrastText: palette.warning.contrastText,
    },
    info: {
      main: palette.info.main,
      light: palette.info.light,
      dark: palette.info.dark,
      contrastText: palette.info.contrastText,
    },
    background: {
      default: palette.background.default,
      paper: palette.background.paper,
    },
    text: {
      primary: palette.text.primary,
      secondary: palette.text.secondary,
      disabled: palette.text.disabled,
    },
    divider: palette.divider,
    grey: palette.grey,
    // Custom status colors
    status: palette.status,
    // Custom accent colors
    accent: palette.accent,
  },

  typography,

  spacing: 8, // 8pt grid system

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },

  shape: {
    borderRadius: 8,
  },

  shadows: [
    'none',
    '0px 2px 4px rgba(30, 41, 59, 0.04)',
    '0px 4px 8px rgba(30, 41, 59, 0.06)',
    '0px 8px 16px rgba(30, 41, 59, 0.08)',
    '0px 12px 24px rgba(30, 41, 59, 0.10)',
    '0px 16px 32px rgba(30, 41, 59, 0.12)',
    '0px 20px 40px rgba(30, 41, 59, 0.14)',
    '0px 24px 48px rgba(30, 41, 59, 0.16)',
    '0px 32px 64px rgba(30, 41, 59, 0.18)',
    '0px 40px 80px rgba(30, 41, 59, 0.20)',
    '0px 2px 4px rgba(30, 41, 59, 0.04)',
    '0px 4px 8px rgba(30, 41, 59, 0.06)',
    '0px 8px 16px rgba(30, 41, 59, 0.08)',
    '0px 12px 24px rgba(30, 41, 59, 0.10)',
    '0px 16px 32px rgba(30, 41, 59, 0.12)',
    '0px 20px 40px rgba(30, 41, 59, 0.14)',
    '0px 24px 48px rgba(30, 41, 59, 0.16)',
    '0px 32px 64px rgba(30, 41, 59, 0.18)',
    '0px 40px 80px rgba(30, 41, 59, 0.20)',
    '0px 48px 96px rgba(30, 41, 59, 0.22)',
    '0px 56px 112px rgba(30, 41, 59, 0.24)',
    '0px 64px 128px rgba(30, 41, 59, 0.26)',
    '0px 72px 144px rgba(30, 41, 59, 0.28)',
    '0px 80px 160px rgba(30, 41, 59, 0.30)',
    '0px 88px 176px rgba(30, 41, 59, 0.32)',
  ],

  components,

  zIndex: {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
});

export default theme;
